import React from "react";
import QuizPanel from "./QuizPanel";
import QuizContent from "./QuizContent";
import "./style.scss";
import LoadingMessage from "../../components/LoadingMessage";
import { useLocaleContext } from "../../context/LocaleContext";
import { useQuizContext } from "../../context/QuizContext";
import { useUserContext } from "../../context/UserContext";
import { useModalContext } from '../../context/ModalContext';
import { useEventContext } from '../../context/EventContext';
import UserAuthenticationModal from '../User/UserAuthenticationModal';

export const WrapperQuiz = ({  isShowHeader = true }) => {
    const { event } = useEventContext();
    const $locale = useLocaleContext();
    const { quiz } = useQuizContext();
    const { user } = useUserContext();
    const { renderModal } = useModalContext();

    const authorizationCheck = () => {
        return new Promise((resolve) => {
            if (!user) {
                renderModal(
                    UserAuthenticationModal,
                    {event, $locale, onClose: (props) => resolve(props?.isAuth)},
                );
            } else {
                resolve(true);
            }
        })
    };

    const quizLoading = null === quiz && $locale.get("quiz.loading");
    const quizNotFound = false === quiz && $locale.get("loading.quiz.notFound");
    const quizNotActive = quiz && (!quiz.enabled || !quiz.polls?.length) && $locale.get("quiz.notActive");
    const quizStatus = quizLoading || quizNotFound || quizNotActive;

    if (quizStatus) {
        return <LoadingMessage isPreloader={quizLoading}>{quizStatus}</LoadingMessage>;
    }

    return <QuizContent quiz={quiz} authorizationCheck={authorizationCheck} isShowHeader={isShowHeader} />;
};

export const Quizzes = ({ quizzes, preview }) => {
    const { participationType } = useUserContext();

    if (null === quizzes) {
        return;
    }

    return (
        <section className="quizzes">
            {quizzes.filter(quiz => preview || (quiz.visible && (!quiz.participationType || quiz.participationType === participationType)))
            .map((quiz) => (
                <QuizPanel key={quiz.quizKey} quiz={quiz} />
            ))}
        </section>
    )
}

const QuizzesContainer = () => {
    const { get: getLocale } = useLocaleContext();
    const { quizzes, isLoading } = useQuizContext();

    if (isLoading) {
        return <LoadingMessage isPreloader>{getLocale("quiz.loading.list")}</LoadingMessage>;
    }

    return <Quizzes quizzes={quizzes} />;
};

export default QuizzesContainer;
